// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"_2FxPQk","clearfix":"_2sGte7","panel":"DrN_E1","forceLastLine":"_21xm6s","panel--last":"_1MWeMy","panelsection":"_2w_zM0","panelsection--last":"_2rjomg"};